// @ts-ignore
import {DateTime} from 'luxon';
import {Owner} from "../../model/customer/owner";
import {ApiValidation} from "../../model/api/api-validation";
import {TableRecordResult} from "../../model/api/table-record-result";
import {Customer} from "../../model/customer/customer";
import {AccountDefinition} from "../../model/customer/account-definition";
import {CrystalclearBackUrl} from "./crystalclear-back-url";
import {AcceptanceRule} from "../../model/customer/acceptance-rule";
import {CustomerLimits} from "../../model/customer/customer-limits";
import {Broker} from "../../model/customer/broker";
import {AccountTrader} from "../../model/customer/account-trader";
import {VatRate} from "../../model/customer/vat-rate";
import {MoneyOwner} from "../../model/customer/money-owner";
import {BrokerageTable} from "../../model/customer/brokerage-table";
import {Trader} from "../../model/customer/trader";
import {ExecTrader} from "../../model/customer/exec-trader";

export class CrystalclearCustomerBackUrl {
  static readonly GET_CUSTOMER_OWNER_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<Owner>> = {
    url: '/api/customer/owner/list',
    type: TableRecordResult
  };

  static readonly SAVE_CUSTOMER_OWNER: CrystalclearBackUrl.UrlConf<ApiValidation<Owner>> = {
    url: '/api/customer/owner/save',
    type: ApiValidation
  };

  static readonly DELETE_CUSTOMER_OWNER: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/customer/owner/delete',
    type: ApiValidation
  };

  static readonly GET_CUSTOMER_CUSTOMER_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<Customer>> = {
    url: '/api/customer/customer/list',
    type: TableRecordResult
  };

  static readonly SAVE_CUSTOMER_CUSTOMER: CrystalclearBackUrl.UrlConf<ApiValidation<Customer>> = {
    url: '/api/customer/customer/save',
    type: ApiValidation
  };

  static readonly SAVE_BATCH_CUSTOMER_CUSTOMER: CrystalclearBackUrl.UrlConf<ApiValidation<Customer>> = {
    url: '/api/customer/customer/save-batch',
    type: ApiValidation
  };

  static readonly CLONE_BATCH_CUSTOMER_CUSTOMER: CrystalclearBackUrl.UrlConf<ApiValidation<Customer>> = {
    url: '/api/customer/customer/clone-batch',
    type: ApiValidation
  };

  static readonly DELETE_CUSTOMER_CUSTOMER: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/customer/customer/delete',
    type: ApiValidation
  };

  static readonly GET_CUSTOMER_EXEC_TRADER_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<ExecTrader>> = {
    url: '/api/customer/exec-trader/list',
    type: TableRecordResult
  };

  static readonly SAVE_CUSTOMER_EXEC_TRADER: CrystalclearBackUrl.UrlConf<ApiValidation<ExecTrader>> = {
    url: '/api/customer/exec-trader/save',
    type: ApiValidation
  };

  static readonly DELETE_CUSTOMER_EXEC_TRADER: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/customer/exec-trader/delete',
    type: ApiValidation
  };


  static readonly GET_CUSTOMER_ACCOUNT_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<AccountDefinition>> = {
    url: '/api/customer/account/list',
    type: TableRecordResult
  };

  static readonly SAVE_CUSTOMER_ACCOUNT: CrystalclearBackUrl.UrlConf<ApiValidation<AccountDefinition>> = {
    url: '/api/customer/account/save',
    type: ApiValidation
  };

  static readonly DELETE_CUSTOMER_ACCOUNT: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/customer/account/delete',
    type: ApiValidation
  };

  static readonly SAVE_BATCH_CUSTOMER_ACCOUNT: CrystalclearBackUrl.UrlConf<ApiValidation<AccountDefinition>> = {
    url: '/api/customer/account/save-batch',
    type: ApiValidation
  };

  static readonly CLONE_BATCH_CUSTOMER_ACCOUNT: CrystalclearBackUrl.UrlConf<ApiValidation<AccountDefinition>> = {
    url: '/api/customer/account/clone-batch',
    type: ApiValidation
  };

  static readonly GET_CUSTOMER_ACCEPTANCE_RULE_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<AcceptanceRule>> = {
    url: '/api/customer/acceptance-rule/list',
    type: TableRecordResult
  };

  static readonly SAVE_CUSTOMER_ACCEPTANCE_RULE: CrystalclearBackUrl.UrlConf<ApiValidation<AcceptanceRule>> = {
    url: '/api/customer/acceptance-rule/save',
    type: ApiValidation
  };

  static readonly DELETE_CUSTOMER_ACCEPTANCE_RULE: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/customer/acceptance-rule/delete',
    type: ApiValidation
  };

  static readonly GET_CUSTOMER_CUSTOMER_LIMITS_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<CustomerLimits>> = {
    url: '/api/customer/customer-limits/list',
    type: TableRecordResult
  };

  static readonly SAVE_CUSTOMER_CUSTOMER_LIMITS: CrystalclearBackUrl.UrlConf<ApiValidation<CustomerLimits>> = {
    url: '/api/customer/customer-limits/save',
    type: ApiValidation
  };

  static readonly DELETE_CUSTOMER_CUSTOMER_LIMITS: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/customer/customer-limits/delete',
    type: ApiValidation
  };

  static readonly GET_CUSTOMER_BROKER_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<Broker>> = {
    url: '/api/customer/broker/list',
    type: TableRecordResult
  };

  static readonly SAVE_CUSTOMER_BROKER: CrystalclearBackUrl.UrlConf<ApiValidation<Broker>> = {
    url: '/api/customer/broker/save',
    type: ApiValidation
  };

  static readonly DELETE_CUSTOMER_BROKER: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/customer/broker/delete',
    type: ApiValidation
  };

  static readonly GET_CUSTOMER_BANK_ACCOUNT_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<Broker>> = {
    url: '/api/customer/bank-account/list',
    type: TableRecordResult
  };

  static readonly SAVE_CUSTOMER_BANK_ACCOUNT: CrystalclearBackUrl.UrlConf<ApiValidation<Broker>> = {
    url: '/api/customer/bank-account/save',
    type: ApiValidation
  };

  static readonly DELETE_CUSTOMER_BANK_ACCOUNT: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/customer/bank-account/delete',
    type: ApiValidation
  };

  static readonly GET_CUSTOMER_ACCOUNT_TRADER_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<AccountTrader>> = {
    url: '/api/customer/account-trader/list',
    type: TableRecordResult
  };

  static readonly SAVE_CUSTOMER_ACCOUNT_TRADER: CrystalclearBackUrl.UrlConf<ApiValidation<AccountTrader>> = {
    url: '/api/customer/account-trader/save',
    type: ApiValidation
  };

  static readonly DELETE_CUSTOMER_ACCOUNT_TRADER: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/customer/account-trader/delete',
    type: ApiValidation
  };

  static readonly SAVE_BATCH_CUSTOMER_ACCOUNT_TRADER: CrystalclearBackUrl.UrlConf<ApiValidation<AccountTrader>> = {
    url: '/api/customer/account-trader/save-batch',
    type: ApiValidation
  };

  static readonly CLONE_BATCH_CUSTOMER_ACCOUNT_TRADER: CrystalclearBackUrl.UrlConf<ApiValidation<AccountTrader>> = {
    url: '/api/customer/account-trader/clone-batch',
    type: ApiValidation
  };

  static readonly GET_CUSTOMER_TRADER_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<Trader>> = {
    url: '/api/customer/trader/list',
    type: TableRecordResult
  };

  static readonly SAVE_CUSTOMER_TRADER: CrystalclearBackUrl.UrlConf<ApiValidation<Trader>> = {
    url: '/api/customer/trader/save',
    type: ApiValidation
  };

  static readonly DELETE_CUSTOMER_TRADER: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/customer/trader/delete',
    type: ApiValidation
  };

  static readonly GET_CUSTOMER_VAT_RATE_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<VatRate>> = {
    url: '/api/customer/vat-rate/list',
    type: TableRecordResult
  };

  static readonly SAVE_CUSTOMER_VAT_RATE: CrystalclearBackUrl.UrlConf<ApiValidation<VatRate>> = {
    url: '/api/customer/vat-rate/save',
    type: ApiValidation
  };

  static readonly DELETE_CUSTOMER_VAT_RATE: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/customer/vat-rate/delete',
    type: ApiValidation
  };

  static readonly GET_CUSTOMER_MONEY_OWNER_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<MoneyOwner>> = {
    url: '/api/customer/money-owner/list',
    type: TableRecordResult
  };

  static readonly SAVE_CUSTOMER_MONEY_OWNER: CrystalclearBackUrl.UrlConf<ApiValidation<MoneyOwner>> = {
    url: '/api/customer/money-owner/save',
    type: ApiValidation
  };

  static readonly DELETE_CUSTOMER_MONEY_OWNER: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/customer/money-owner/delete',
    type: ApiValidation
  };

  static readonly GET_CUSTOMER_BROKERAGE_TABLE_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<BrokerageTable>> = {
    url: '/api/customer/brokerage-table/list',
    type: TableRecordResult
  };

  static readonly SAVE_CUSTOMER_BROKERAGE_TABLE: CrystalclearBackUrl.UrlConf<ApiValidation<BrokerageTable>> = {
    url: '/api/customer/brokerage-table/save',
    type: ApiValidation
  };

  static readonly DELETE_CUSTOMER_BROKERAGE_TABLE: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/customer/brokerage-table/delete',
    type: ApiValidation
  };

}
